import { Box } from "@mui/material";
import type { ToolGuideReadoutAxis } from "src/domains/shared/utils/toolGuideMessage";

/**
 * 측정 축 아이콘 — 입체(대각선+화살), 평면(파선), 높이(양방향 화살). 선 중간의 측정 라벨(3D `MeasurementLabel`)과
 * 안내 칩의 실시간 값 줄이 같은 모양을 읽는다. 색은 호출자가 축 토큰에서 준다(지도 엔진 상수 비의존).
 */
export function MeasurementAxisIcon({
  axis,
  color = "currentColor",
}: {
  axis: ToolGuideReadoutAxis;
  color?: string;
}) {
  return (
    <Box
      component="svg"
      viewBox="0 0 10 10"
      aria-hidden
      sx={iconBox}
      style={{ stroke: color }}
    >
      {axis === "solid" && (
        <>
          <path d="M2 8 L8 2" />
          <path d="M4.5 2 H8 V5.5" />
        </>
      )}
      {axis === "plane" && <path d="M1 5 H9" strokeDasharray="2.6 1.6" />}
      {axis === "guide" && (
        <>
          <path d="M5 1.5 V8.5" />
          <path d="M3 3.5 L5 1.5 L7 3.5" />
          <path d="M3 6.5 L5 8.5 L7 6.5" />
        </>
      )}
    </Box>
  );
}

const iconBox = {
  flex: "0 0 auto",
  width: "10px",
  height: "10px",
  fill: "none",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
} as const;
